export default "assets/images/icons/facebook-4fe7bd83.svg";